export default "__VITE_ASSET__COcP8tfh__"